import React, { Fragment } from "react";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MinimizeRoundedIcon from '@mui/icons-material/MinimizeRounded';
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import { Dialog, Transition } from "@headlessui/react";

export default function SliderPanel(props) {
    const open = true
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-1000 emailpreview" onClose={props.onClick}>
        <Transition.Child
          as={Fragment}
          enter="ease-in-out duration-500"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in-out duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-100 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto emailpreviewwrapper">
                  <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                    {/* <div className="px-4 sm:px-6">
                      <div className="flex items-start justify-between">
                        <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
                          Email Preview
                        </Dialog.Title>
                        <div className="ml-3 flex h-7 items-center">
                          <button
                            type="button"
                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={props.onClick}
                          >
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                    </div> */}
                    <div className="email-temaplate-preview-header">
                    <div>Email Template Preview</div>
                    <div className="text-right">
                    <MinimizeRoundedIcon
                fontSize="medium"
                className="previewtemplateicon"
                style={{ cursor: 'pointer' }}
              />
              <OpenInFullRoundedIcon
                fontSize="medium"
                className="previewtemplateicon"
                style={{ cursor: 'pointer' }}
              />
              <CloseRoundedIcon
                fontSize="medium"
                className="previewtemplateicon"
                style={{ cursor: 'pointer' }}
              />
                    </div>
                    </div>
                    <div className="email-temaplate-preview-body">
                    <div>To</div>
                    <div>Cc</div>
                    <div>Subject</div>
                    </div>
                    <div className="relative mt-6 flex-1 px-4 sm:px-6" dangerouslySetInnerHTML={{__html: props.innerHtmlContent}}>
                      {/* {props.innerHtmlContent} */}
                    </div>
                    {/* <div className="email-temaplate-preview-footer">

                    </div> */}
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
